import { jsx as _jsx } from "react/jsx-runtime";
import { NewsletterSubscribeFeedbackTypes } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NewsletterSubscribeForm } from '../components/newsletter-subscribe-form/NewsletterSubscribeForm';
import { DELAY } from '../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import sessionActions from '../redux/session/actions/SessionActions.creators';
import { getBoxPropsFromAEMPaddings } from '../util/AEMUtil';
const NewsletterSubscribeContainer = ({ redirectUrl, buttonLabel, title, paddings, borders, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [feedbackState, setFeedbackState] = useState();
    const handleSuccess = () => {
        dispatch(sessionActions.createNewsletterSubscribeAction());
        if (redirectUrl) {
            window.location.href = getHomepageUrl(redirectUrl);
        }
        else {
            setFeedbackState(NewsletterSubscribeFeedbackTypes.SUCCESS);
            setTimeout(() => setFeedbackState(undefined), DELAY.DELAY_2000);
        }
    };
    const handleFail = (state = NewsletterSubscribeFeedbackTypes.ERROR) => {
        setFeedbackState(state);
        setTimeout(() => setFeedbackState(undefined), DELAY.DELAY_2000);
    };
    const getFeedbackMessage = (state) => {
        switch (state) {
            case NewsletterSubscribeFeedbackTypes.SUCCESS:
                return t('account.subscribe.confirmMessage');
            case NewsletterSubscribeFeedbackTypes.ALREADY_SUBSCRIBED:
                return t('account.subscribe.alreadySubscribedMessage');
            default:
                return t('account.subscribe.errorMessage');
        }
    };
    const wrapperClassNames = useMemo(() => `${Object.values(borders).filter(Boolean).join(' ')}`, [borders]);
    return (_jsx("div", { className: wrapperClassNames, children: _jsx(Box, Object.assign({}, getBoxPropsFromAEMPaddings(paddings), { children: _jsx(NewsletterSubscribeForm, { title: title ? (_jsx(TextAlpha, { as: "h2", variant: "subheadingS", children: title })) : undefined, submitButtonText: buttonLabel, onSuccess: handleSuccess, onFail: handleFail, feedbackState: feedbackState, feedbackMessage: getFeedbackMessage(feedbackState) }) })) }));
};
export default NewsletterSubscribeContainer;
